import React from "react";
import Preloader from "../../helper/Preloader";
 import Breadcrumb from "../../components/Breadcrumb";
  import ScrollToTop from "react-scroll-to-top";
import HeaderOneCustomer from "../../componentsAmazon/HeaderOneCustomer"; 
import ReturnedProductList from "../../componentsAmazon/ReturnedProductList";
import FooterOne from "../../components/FooterOne";

const ReturnedProductAmazon = () => {
 
  return (
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      <HeaderOneCustomer category={true} />
 

{/* ReturnedProductList   */}
<ReturnedProductList />

  
      {/* FooterOne */}
      <FooterOne />


    </>
  );
};

export default ReturnedProductAmazon;
